<template>
<v-expansion-panels
      :accordion="true"
      :flat="true"
      :hover="true"
      v-if="allPayments.length"
      text-sm-left
    >
      <v-expansion-panel v-for="(item,i) in allPayments" :key="i">
        <v-expansion-panel-header>Data de Referência: <span style="color: #b71c1c; padding-left: 12px"> {{item.referencia}}</span> Valor: <span style="color: green; padding-left: 12px">  {{item.total | formatPrice}}</span></v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-divider />
          <h3 class="text-left mt-2 mb-4">Detalhamento</h3>
           <v-carousel height="350px" light hide-delimiter-background show-arrows-on-hover>
              <v-carousel-item v-for="(detail,ind) in item.detalhes"  :key="ind" pa-3>
              <v-card  class="text-left">
                <v-card-text>
                  <p>Beneficiário: <span style="color: green; padding-left: 12px">{{ detail.beneficiario }}</span></p>
                  <p>Data do evento: <span style="color: green; padding-left: 12px">{{ detail.dataevento | moment("DD/MM/YYYY")}}</span></p>
                  <p>Local: <span style="color: green; padding-left: 12px">{{ detail.local }}</span></p>
                  <p>Descrição: <span style="color: green; padding-left: 12px">{{ detail.descricao }}</span></p>
                  <p>valor unitário: <span style="color: green; padding-left: 12px">{{ detail.valorevento | formatPrice }}</span></p>
                  <p>Quantidade: <span style="color: green; padding-left: 12px">{{ detail.quantidade }}</span></p>
                  <p>Total: <span style="color: green; padding-left: 12px">{{ detail.valortotal | formatPrice}}</span></p>
                </v-card-text>
              </v-card>
              </v-carousel-item>
           </v-carousel>
          
        </v-expansion-panel-content>
        <v-divider />
      </v-expansion-panel>
    </v-expansion-panels>
  <p v-else> Você não efetuou nenhum pagamento nos últimos 12 meses.</p>
</template>
<script>
export default {
  data () {
    return { }
  },
  props: {
    allPayments: Array
  },
}
</script>
<style>
.v-carousel .v-btn--outlined .v-btn__content .v-icon,
.v-carousel .v-btn--outlined .v-btn__content .v-icon:before,
.v-carousel .v-btn--round .v-btn__content .v-icon,
.v-carousel .v-btn--round .v-btn__content .v-icon:before {
    font-size: 8px;
  }
.v-carousel .v-btn--icon.v-size--default .v-icon, .v-btn--fab.v-size--default .v-icon {
    height: 16px;
    font-size: 8px;
    min-width: 16px;
}
</style>
